export default __webpack_public_path__ + "static/media/andres2.ea774219.jpg";